// Filter-aware footer stats (PRD_FilterAwareFooterStats C1).
// The primary footer stat on every list page renders "{filtered} of {total}"
// while a filter/search is active, and the plain total otherwise. This helper
// pins the exact format in one place; each page derives `filterActive` from
// the identical condition its own filter code tests (C3).
export const formatFilteredCount = (filtered, total, filterActive) =>
  filterActive ? `${filtered} of ${total}` : String(total);
